//eslint-disable-next-line
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import DefaultLayout from '~/layouts';
import { privateRoutes, publicRoutes } from '~/routes';
import PageNotFound from './pages/PageNotFound';

import './App.scss';
import { createBrowserHistory } from 'history';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { ScrollToTop } from './utils';
import config from './config';
const history = createBrowserHistory({ window });

function App() {
    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';

    return (
        <HistoryRouter history={history}>
            {/* <Router> */}
            <div className="App">
                <ScrollToTop>
                    <Routes>
                        {publicRoutes?.map((route, index) => {
                            const Page = route.component;

                            let Layout = DefaultLayout;

                            if (route.layout) {
                                Layout = route.layout;
                            } else if (route.layout === null) {
                                Layout = Fragment;
                            }

                            return (
                                <Route
                                    key={index}
                                    path={route.path}
                                    element={
                                        route.path.includes(config.routes.receiveRewarded) ||
                                        route.path.includes(config.routes.downloadAPP) ||
                                        route.path.includes(config.routes.middleShare) ? (
                                            <Page />
                                        ) : (
                                            <Layout>
                                                <Page />
                                            </Layout>
                                        )
                                    }
                                />
                            );
                        })}
                        {privateRoutes?.map((route, index) => {
                            const Page = route.component;

                            let Layout = DefaultLayout;

                            if (route.layout) {
                                Layout = route.layout;
                            } else if (route.layout === null) {
                                Layout = Fragment;
                            }
                            return (
                                <Route
                                    key={index}
                                    path={route.path}
                                    element={
                                        isLogin ? (
                                            <Layout>
                                                <Page />
                                            </Layout>
                                        ) : (
                                            <PageNotFound />
                                        )
                                    }
                                />
                            );
                        })}
                    </Routes>
                </ScrollToTop>
            </div>
            {/* </Router> */}
        </HistoryRouter>
    );
}

export default App;
